<template>
  <el-row>
    <el-col :lg="8">
      {{ title }}<br>
      <small>{{ subtitle  }}</small>
    </el-col>
    <el-col :offset="8" :lg="8" v-if="customer">
      <CustomerList v-on:selected="selected" />
    </el-col>
  </el-row>
</template>

<script>
import CustomerList from "../../xpost/views/register/customer/CustomerList.vue";
export default {
  name: 'PageTitle',
  props: ['title', 'subtitle', 'customer'],
  components: {
    CustomerList,
  },
  methods: {
    selected(id, name) {
      this.$emit('change', { id, name });
    },
  }
}
</script>